const zhCN = {
  startTimeTxt: '开始时间',
  endTimeTxt: '结束时间',
  aWeekBeforeBtn: '前一周',
  oneMonthBeforeBtn: '前一个月',
  threeMonthsBeforeBtn: '前三个月',

  searchBtn: '搜索',

  operatorTypeTxt: '数据来源',
  option_all: '全部',

  logLoading: '加载日志中...',
  getLogFail: '获取日志失败！',

  operationLog: '操作日志',
  workLog: '设备工作日志',
  syncLog: '数据同步日志',
  noData: '暂无数据',

  today: '今天',
  yesterday: '昨天',
  beforeYesterday: '前天'
}
const enUS = {
  startTimeTxt: 'Start Time',
  endTimeTxt: 'End Time',
  aWeekBeforeBtn: 'a week before',
  oneMonthBeforeBtn: 'one month before',
  threeMonthsBeforeBtn: 'three months before',
  
  searchBtn: 'Search',

  operatorTypeTxt: 'Data sources',
  option_all: 'All',

  logLoading: 'Loading Log...',
  getLogFail: 'Get log failed!',

  operationLog: 'Operation Log',
  workLog: 'Work Log',
  syncLog: 'Sync Log',
  noData: 'No Data',

  today: 'Today',
  yesterday: 'Yesterday',
  beforeYesterday: 'Before Yesterday'
}

export default { zhCN, enUS }